import { Component, OnInit, EventEmitter, Output, Input, ViewChild, TemplateRef } from '@angular/core';
import { PropertyManagementService } from '../../../../shared/providers/property-management.service';
import { IPropertyDetails, PropertyDocuments } from '../../../../shared/models/propertydetails';
import { ILookUp } from '../../../../shared/models/LookUpOutputModel';
import { CommonService } from '../../../../shared/providers/common.service';
import { ToastService } from '../../../../shared/providers/toast.service';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { FileUploadService } from '../../../../shared/providers/fileupload.service';
import { IFileUpload, IPropertyFileUpload } from '../../../../shared/models/fileupload';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from '../../../../shared/models/datatables-response';
import { ValidationService } from '../../../../shared/providers/validation.service';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { DashboardService } from '../../../../shared/providers/dashboard.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { INoteInput } from '../../../../shared/models/NotesInputModel';
import { Router } from '@angular/router';
import { AuthService } from '../../../../shared/auth/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-bovinformation-upload',
  templateUrl: './bovinformation-upload.component.html',
  styleUrls: ['./bovinformation-upload.component.css']
})
export class BOVInformationUploadComponent implements OnInit {

  @Input() propertyId: number = 0;
  @Input() property = {} as IPropertyDetails;
  @Input() BackgroundFileStoring: number = 0;
  //@Output() fileUploaded = new EventEmitter();
  propertyDocuments = [] as PropertyDocuments[];
  uploadedFiles: IPropertyFileUpload[] = [];
  fileExtensionType = 'document'
  fileUploadType = 'multiple';
  docCategories = [] as ILookUp[];
  errorMessage: string;
  showRemoveButton: boolean = false;
  selectedFiles: string[] = [];
  selectedFilesForDocs: string[] = [];
  inputFileUpload = {} as IFileUpload;
  clearFiles: number = 0;
  filesCollection = [];
  latestId = 0;
  table: DataTableDirective;
  dtOptions = {};
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  protected readonly BASE_URL: string = environment.base_url;
  rowCount: number;
  modalRef: BsModalRef;
  modalRefEdit: BsModalRef;
  modalRefUpload: BsModalRef;
  removeModalRef: BsModalRef;
  UpdateItem = {};
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  categoryId: number;
  Note: string;
  checkList = [];
  IsAdmin = false;
  documentPreview: BsModalRef;
  docPreview: any;
  user: any;
  IsBroker = false as boolean;
  IsSeller = false as boolean;
  subscription: Subscription = new Subscription();
  IsFileUploadConfirmed: boolean = false;
  @ViewChild('UploadConfirmation') uploadConfirmation: TemplateRef<any>;
  modalRefuploadConfirmation: BsModalRef;
  constructor(private _propertyManagementService: PropertyManagementService,
    private _commonService: CommonService,
    private _toastService: ToastService,
    private _loaderService: LoaderService,
    private _fileUploadService: FileUploadService,
    private _validationService: ValidationService,
    private http: HttpClient,
    private _dashboardService: DashboardService,
    private router: Router,
    private modalService: BsModalService,
    private _auth0: AuthService,
    private _authenticationService: AuthenticationService) { }

  ngOnInit() {
    this.user = this._authenticationService.user;
    this.IsAdmin = (this._authenticationService.Admin() || this._authenticationService.SuperAdmin());
    this.IsBroker = this._authenticationService.Broker();
    this.IsSeller = this._authenticationService.Seller();
    this.bindTable();
    this.getCheckList()
    this._propertyManagementService.getFileCategories(6806).subscribe(response => {
      this.docCategories = response.map(o => {
        return { id: o.Id, description: o.Description };
      });
    });

    let imageData = JSON.parse(localStorage.getItem('UploadedImageList'));
    if (imageData != null && imageData != undefined) {
      let ongoingList = imageData.filter(f => f.ImageStatus == '' || f.ImageStatus == null && f.sourceUrl == this.router.url && f.RefreshTab == 'BOV-Files');
      if (ongoingList != null && ongoingList.length > 0) {
        localStorage.setItem('currentFileRefreshTab', 'BOV-Files');
      }
      else if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
        localStorage.removeItem('currentFileRefreshTab');
      }
    }

    this.subscription.add(this._auth0.customObservable.subscribe((res) => {
      if (res.sourceUrl == this.router.url && localStorage.getItem('currentFileRefreshTab') == 'BOV-Files' && res.refreshTab == 'BOV-Files') {
        this.dtElement.dtInstance.then(x => x.draw(false));
      }
    }
    ));

  }

  refreshFiles($event) {
    this.dtElement.dtInstance.then(x => x.draw(false));
  }

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.errorMessage = null;
    this.selectedFiles = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    this.selectedFiles.forEach(item => {
      const fileObj =
      {
        name: item["name"],
        category: 0,
        file: item
      }
      this.filesCollection.push(fileObj);
    });
  }


  onFilesClear() {
    this.clearFiles++;
    this.selectedFiles = [];
    this.filesCollection = [];
  }

  uploadFiles() {
    this._loaderService.display(true);
    let valid = true;
    //if (this.modalRefuploadConfirmation !== undefined) {
    //  this.modalRefuploadConfirmation.hide();
    //}
    for (let i = 0; i < this.filesCollection.length; i++) {
      if (parseInt(this.filesCollection[i]["category"]) === 0) {
        this._toastService.addToast({ title: 'Error Occurred', msg: "Please Select Catogory", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this._loaderService.display(false);
        valid = false;
        break;
      }
    }
    if (valid) {
     /* if (this.IsFileUploadConfirmed) {*/
        let uploadCount = 1;
        this.filesCollection.forEach(item => {
          let fileToUpload = [];
          fileToUpload.push(item["file"]);
          this.uploadedFiles.push({
            id: 0,
            objectId: this.propertyId,
            type: 'Documents',
            documentName: item["name"],
            fileCategoryId: item["category"],
            objectTypeId: 313,
            FileContent: null,
            isDefault: false,
            ImageGuid: this.newGuid(),
            PropertyGuid: '',
            ImageStatus: '',
            fileToUpload: fileToUpload,
            sourceUrl: this.router.url,
            RefreshTab: 'BOV-Files'
          });
          //  this.inputFileUpload.documentName = item["name"];
          //  this.inputFileUpload.fileCategoryId = item["category"];
          //  this.inputFileUpload.id = 0;
          //  this.inputFileUpload.objectId = this.propertyId;
          //  this.inputFileUpload.objectTypeId = 313;
          //  this.inputFileUpload.type = "Documents";

          //  let fileToUpload = [];
          //fileToUpload.push(item["file"]);
          //  this._fileUploadService.uploadFiles(this.inputFileUpload, fileToUpload).subscribe(res => {
          //    if (res != null) {
          //      if (uploadCount == this.filesCollection.length) {
          //        //this.fileUploaded.emit();

          //        this.onFilesClear();
          //        this._loaderService.display(false);
          //        this._toastService.addToast({ title: 'Success', msg: "Files Uploaded Successfully", timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          //        this.dtElement.dtInstance.then(x => x.draw(false));
          //        this.getCheckList();
          //      }
          //      uploadCount++;
          //    }
          //  });
        });
        this.clearFiles++;
        if (this.uploadedFiles != null) {
          this.imageupload();
          if (this.modalRefUpload != undefined) {
            this.modalRefUpload.hide();
          }
          this.onFilesClear();
          this._loaderService.display(false);
          this._toastService.addToast({ title: '', msg: "File uploads are in progress, please don't reload or close the website until complete.", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'info' });
        }
      //}
      //else {
      //  this._loaderService.display(false);
      //  this.IsFileUploadConfirmed = true;
      //  this.modalRefuploadConfirmation = this.modalService.show(this.uploadConfirmation, { class: 'deletemodal' });
      //}
    }
  }
  imageupload() {
    localStorage.setItem('currentFileRefreshTab', 'BOV-Files');
    this._auth0.FileUpload(this.uploadedFiles);
    this.uploadedFiles = [];
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  bindTable() {

    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
      },
      "pageLength": 20,
      "order": [[1, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {

        dataTablesParameters.Extra_param = {
          PropertyId: that.propertyId
        }
        const httpHeader = this._validationService.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/Property/GetAllBOVDocumentsByPropertyId',
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.propertyDocuments = resp.data ? resp.data : [];
            this.rowCount = resp.recordsTotal;
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
          });
      },
      columns: [{ data: 'Name' },
      { data: 'Name' },
      { data: 'CategoryId' },
      { data: 'UploadedBy' },
      { data: 'UploadedDate' }]
    };
  }

  editfileCategoryId: number;
  UpdateDocCategory() {
    this._dashboardService.saveBOEPropertyDocumentCategory(this.editFileId, this.editfileCategoryId, true, this.user.Id).subscribe(res => {
      this.getCheckList();
      this.modalRefEdit.hide();
      this.dtElement.dtInstance.then(x => x.draw(false));
      this._toastService.addToast({ title: 'Success', msg: 'Document category updated successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    })
  }

  deleteBOVDoc(doc) {
    this._dashboardService.saveBOEPropertyDocumentCategory(doc.Id, doc.CategoryId, false, this.user.Id).subscribe(res => {
      this.dtElement.dtInstance.then(x => x.draw(false));
      this.getCheckList();
    })
  }

  removeDoc(fileIndex: number, event: any) {
    if (fileIndex > -1) {
      this.filesCollection.splice(fileIndex, 1);
    }
  }

  removeModel(template: TemplateRef<any>, classes, document) {
    this.removeModalRef = this.modalService.show(template, { class: classes });
    document.IsActive = false;
    this.UpdateItem = Object.assign({}, document);
  }

  editFileId: number;

  openEditModal(template: TemplateRef<any>, classes: any, id: number, category: number) {
    this.editfileCategoryId = category;
    this.editFileId = id;
    this.modalRefEdit = this.modalService.show(template, { class: classes });
  }

  onAddOrEditNotes(template: TemplateRef<any>, classes, category) {

    this.categoryId = category.Id;
    this.Note = category.Notes
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  onClose() {
    this.modalRef.hide();
  }

  getCheckList() {
    this.checkList = [];
    this._dashboardService.GetBOVChecklistByPropertyId(this.propertyId, this.user.Id).subscribe(res => {
      let chklst = res.filter(x => x.Id != 401); // 401 Offering Memorandum 
      this.checkList.push(chklst.filter(x => x.Id == 405)[0]); // 405 lease 
      chklst.filter(x => x.Id != 405).forEach(item => {
        this.checkList.push(item)
      });
    });
  }

  saveNote() {
    this.checkList.forEach(item => {
      if (item.Id == this.categoryId) {
        item.Notes = this.Note
      }
    })
    let notes = [];
    notes.push(this.Note);
    this._dashboardService.saveBOVChecklistByPropertyId(this.propertyId, this.categoryId, notes).subscribe(res => {
      if (res) {
        this.getCheckList()
        this.onClose();
      }
    })
  }

  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
  }

  modalNoteRef: BsModalRef;
  isSubmit = false;
  NotesInput = {} as INoteInput;

  openModalForNotes(template: TemplateRef<any>, classes, itemLead) {
    this.isSubmit = false;
    this.NotesInput.Id = 0;
    this.NotesInput.Description = '';
    this.NotesInput.UserId = this.user.Id;
    this.NotesInput.ObjectId = this.propertyId;
    this.NotesInput.LeadChecklistId = itemLead.Id;
    this.NotesInput.ObjectTypeId = 312;
    itemLead.UnReadNoteCount = 0;
    this.modalNoteRef = this.modalService.show(template, { class: classes });
  }

  closeModal() {
    this.modalNoteRef.hide();
  }
  OpenAddFileSlider(template: TemplateRef<any>, classes: any) {
    this.modalRefUpload = this.modalService.show(template, { class: classes });
  }
  CloseFile() {
    if (this.modalRefUpload != undefined) {
      this.modalRefUpload.hide();
    }
    this.clearFiles++;
    this.selectedFiles = [];
    this.filesCollection = [];
  }
}
